import styled from 'styled-components'

export const Label = styled.label`
  font-family: ${(props) => props.theme.labelFontFamily};
  color: ${(props) => props.theme.labelTextColour};
  font-size: ${(props) => props.theme.labelFontSize};
  text-align: left;
  display: block;
`
